import { FC, HTMLAttributes, ReactNode } from "react";
import { useAvatar } from "src/hooks";

interface Props extends HTMLAttributes<HTMLDivElement> {
	user: StoreUser;
	iconEvent?: () => void;
	icon?: ReactNode;
}

const UserChipItem: FC<Props> = ({ user, iconEvent, icon }) => {
	const { data: src, isLoading, isError } = useAvatar({ userId: user.uuid });

	const initials = user.name
		? user.name
				.split(" ")
				.map((n) => n[0])
				.join("")
				.slice(0, 2)
				.toUpperCase()
		: "?";

	return (
		<div className="flex items-center gap-2">
			{/* Avatar with skeleton loading state */}
			<div className="flex-shrink-0">
				{isLoading ? (
					<div className="w-10 h-10 rounded-full bg-muted animate-pulse" />
				) : (
					<div className="w-10 h-10 rounded-full bg-foreground text-white flex items-center justify-center text-sm font-medium overflow-hidden">
						{!isError && src ? (
							<img
								src={src}
								alt={user.name}
								className="w-full h-full object-cover"
							/>
						) : (
							<span>{initials}</span>
						)}
					</div>
				)}
			</div>

			<div className="flex flex-col flex-1 min-w-0 text-left">
				<p className="font-medium text-sm text-foreground truncate">
					{user.name}
				</p>
				{user.role && (
					<p className="text-[13px] text-muted-foreground truncate">
						{user.role}
					</p>
				)}
			</div>

			{icon && (
				<button onClick={iconEvent} type="button">
					{icon}
				</button>
			)}
		</div>
	);
};

export default UserChipItem;
